// client/src/firebaseFrontend.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCAUHShJmaaqyrtVL0RHrCqI_pWhOHwmtc",
  authDomain: "mfr-build.firebaseapp.com",
  projectId: "mfr-build",
  storageBucket: "mfr-build.firebasestorage.app",
  messagingSenderId: "1074127700835",
  appId: "1:1074127700835:web:78f94c67d27689cb6d4956",
  measurementId: "G-D177WQQXGC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Token generate kar ke Backend par bacha ke rakhne ka function
export const requestForToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // 🔥 HIGHLIGHT: Aapki real VAPID key yahan fit kar di hai
      const currentToken = await getToken(messaging, { 
        vapidKey: "BNaKUXsRZEjE70o2f_4vIIqgct_jXHOmjNpNVd2VQRVcYAp1wE9kMR3iEuujMxERCTBaeoSNKw-gNXeWDOmXDXA" 
      });
      
      if (currentToken) {
        localStorage.setItem("fcm_token", currentToken);
        return currentToken;
      }
    }
  } catch (err) {
    console.log("An error occurred while retrieving token. ", err);
  }
};